import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Heading, Link, Paragraph } from '@digdir/designsystemet-react';
import type { PlanArea } from '../../../api/workEnvironmentTypes';
import { otherAreasAtRisk } from '../followUpView';
import { dayAndMonth } from '../surveyProcessView';
import process from '../WorkEnvironmentSurveyProcess.module.css';

type Props = { areas: PlanArea[]; canChange: boolean; onPlan: () => void };

export const OtherAreasCard = ({
  areas,
  canChange,
  onPlan,
}: Props): ReactElement | null => {
  const { t, i18n } = useTranslation();
  const { count, deadline } = otherAreasAtRisk(areas);
  if (count === 0) return null;
  return (
    <section
      aria-labelledby="follow-up-other-heading"
      className={`${process.card} ${process.sideCard}`}
    >
      <Heading level={2} data-size="xs" id="follow-up-other-heading">
        {t('workEnvironmentFollowUp.other.title')}
      </Heading>
      <Paragraph data-size="sm">
        {t('workEnvironmentFollowUp.other.text', { count })}
        {deadline &&
          ` ${t('workEnvironmentFollowUp.other.deadline', { date: dayAndMonth(deadline, i18n.language) })}`}
      </Paragraph>
      {canChange && (
        <div>
          <Link asChild>
            <button type="button" onClick={onPlan}>
              {t('workEnvironmentFollowUp.other.action')}
            </button>
          </Link>
        </div>
      )}
    </section>
  );
};
